import { API_ENDPOINT } from './config';

export const urlsPolls = {
  // Polls
  polls: `${API_ENDPOINT}/polls`,
  pollDetail: (id) =>
    id ? `${API_ENDPOINT}/polls/${id}` : `${API_ENDPOINT}/polls`,
  pollResultToPublic: (id) => `${API_ENDPOINT}/polls/results-to-public/${id}`,
  votePoll: `${API_ENDPOINT}/polls/vote-poll`,
  activateDeactivatePoll: `${API_ENDPOINT}/polls/activate-deactivate-poll`,
  activePollForVote: `${API_ENDPOINT}/polls/active-poll-for-vote`,
  activePollVoted: (userId) =>
    `${API_ENDPOINT}/polls/user-active-poll-response/${userId}`,
  pollResults: (pollResult) => `${API_ENDPOINT}/polls/results/${pollResult}`,

  // Response collections (polls helpers)
  responseCollections: `${API_ENDPOINT}/response-collections`,
  responseCollectionsMapped: `${API_ENDPOINT}/response-collections/mapped`,
  responseCollectionsTeachingStaff: `${API_ENDPOINT}/response-collections/sources/teaching-staff`,
  responseCollectionsSubjects: `${API_ENDPOINT}/response-collections/sources/subjects`,
  responseCollectionActive: (id) =>
    `${API_ENDPOINT}/response-collections/${id}/active`,
};

export const routesPolls = {
  // Public
  polls: 'anketa',

  // CMS
  cmsPolls: '/cms/polls',
  cmsPollEdit: '/cms/polls/edit',
  cmsPollCreate: '/cms/polls/create',
  cmsPollResults: '/cms/polls/results',

  // Response collections (polls helpers)
  cmsAddResponseCollection: '/cms/polls/response-collections/create',
  cmsResponseCollections: '/cms/response-collections',
  cmsResponseCollectionsEdit: '/cms/response-collections/edit',
  cmsResponseCollectionsCreate: '/cms/response-collections/create',
};
